import { keyframes } from 'styled-components';
export const pulsate = keyframes(["0%{opacity:1;}100%{opacity:0.5;}"]);